import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaCardComponent } from '@global-front-components/ui/card';
import { TranslateModule } from '@ngx-translate/core';
import { AutosBusquedaStoreService } from '../../services/store/autos-busqueda-store.service';
import { TipoVehiculo } from '../../../comun/model/autos.model';
import { CaTooltipDirective } from '@global-front-components/ui/tooltip';
@Component({
	selector: 'app-tipo-vehiculo',
	standalone: true,
	imports: [
		CommonModule,
		CaCardComponent,
		CaTooltipDirective,
		TranslateModule
	],
	templateUrl: './tipo-vehiculo.component.html',
	styleUrls: ['./tipo-vehiculo.component.scss', '../buscar-version-manual/buscar-version-manual.component.scss']
})
export class TipoVehiculoComponent implements OnInit {
	@Output() pasoSeleccionado = new EventEmitter<void>();
	
	public tiposVehiculo: TipoVehiculo[];
	constructor(private autosStore: AutosBusquedaStoreService) { }

	ngOnInit(): void {
		this.autosStore.tiposVehiculoSubject$.subscribe({
			next: (tiposVehiculo) => {
				this.tiposVehiculo = tiposVehiculo;
			},
			error: (err) => console.error('Error recuperando tipos de vehiculo:', err),
		});
	}

	seleccionarTipoVehiculo(tipo: TipoVehiculo): void {
		this.autosStore.setIdTipoVehiculoSeleccionado(tipo.categoria);
		this.autosStore.getMarcasDestacadas(tipo.categoria);
		this.autosStore.getMarcas(tipo.categoria);

		this.pasoSeleccionado.emit();
	}
}
